import { lmsClient } from "api";

const ReversalSuspend = {};

function buildQuery(params) {
  return Object.entries(params)
    .filter(([_, v]) => v !== null && v !== undefined && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
}

ReversalSuspend.getReversalSuspend = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;

  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    description: data?.description,
    amountFrom: data?.amountFrom,
    amountTo: data?.amountTo,
    bankAccountId: data?.bankAccountId,
    referenceNo: data?.referenceNo,
    postingDate: data?.postingDate,
  };
  return lmsClient({
    url: `/lms/SuspendReversal/searchListSuspendReversal?${buildQuery(params)}`,
    method: "get",
  });
};

ReversalSuspend.addReversalSuspend = function (data) {
  return lmsClient({
    url: `/lms/SuspendReversal/add`,
    method: "post",
    data: data,
  });
};

ReversalSuspend.postSuspendReversal = function (data) {
  return lmsClient({
    url: `/lms/SuspendReversal/SuspendReversal`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "x-requestId": data?.id,
    },
    data: data?.data,
  });
};

ReversalSuspend.fetchApproveReversal = function (data) {
  return lmsClient({
    url: `/lms/SuspendReversal/ApproveReversalSuspend`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "x-requestId": data?.id,
    },
    data: data?.data,
  });
};

ReversalSuspend.ApproveSuspendSplit = function (data) {
  return lmsClient({
    url: `/lms/SuspendSplit/ApproveSuspendSplit`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "x-requestId": data?.id,
    },
    data: data?.data,
  });
};

export default ReversalSuspend;
